export default "/asset/tutorial-page3.6e6f20d8.png";